import React, { useEffect, useState, useRef } from 'react';
import {
  FormGroup, Container, Grid, TextField,
  Autocomplete,
} from '@mui/material';
import { useHistory, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import api from '../../../services/api';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import { useFormik } from 'formik';
import SaveButton from '../../../components/Buttons/SaveButton';
import geocoding from '../../../components/geocoder';
import axios from 'axios';
import maskPhone from '../../../components/Masks/maskPhone';
import maskCNPJ from '../../../components/Masks/maskCNPJ';
import Progress from '../../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';

import { setDisable } from '../../../redux/disable';
import { setLoading } from '../../../redux/loading';
import Success from '../../../components/Snack/Success';
import Error from '../../../components/Snack/Error';
import { useStyles } from '../../../components/Styles';

mapboxgl.accessToken = 'pk.eyJ1Ijoib3RvbmNicmFnYSIsImEiOiJjazM4Mm1xd2owMGk0M2NzNXMwYjNuOGI4In0.qHXOUHYT4sH5q8cjLlOAtw';

function PropertyChoose() {
  const [open, setOpen] = useState(true);
  const [openError, setOpenError] = useState(false);
  const [openDia, setOpenDia] = useState(false);
  const [selectedProperty, handleSelectedProperty] = useState(null);
  const [selectedState, handleState] = useState(null);
  const [selectedCity, handleCity] = useState(null);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const disableB = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();
  const dispatch = useDispatch();
  let map; let geocoder; let
    marker;
  const mapContainer = useRef(null);
  const classes = useStyles();
  const { id } = useParams();

  const history = useHistory();

  const handleClose = () => {
    setOpen(false);
  };

  async function request(data) {
    // envia os dados para api salvar no banco
    try {
      if (id != null) {
        await api.put(`/properties/${id}`, { ...data });
      } else {
        await api.post('/properties', { ...data }).then((resp) => {
          localStorage.setItem('idProperty', resp.data.id);
          localStorage.setItem('nameProperty', resp.data.name);
        });
      }
      success();
      history.push('/admin/listproperties');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  useEffect(() => {
    // carrega os dados no seu devido campo caso tenha id, do contrário,
    // carrega o formulário vazio para cadastrar um novo
    map = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/satellite-streets-v11',
      center: [formik.values.longitude, formik.values.latitude],
      zoom: 17,
    });

    geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      localGeocoder: geocoding,
      zoom: 17,
      placeholder: 'Localização',
      language: 'pt-BR',
      marker: false,
      mapboxgl,
    });

    marker = new mapboxgl.Marker()
      .setLngLat([formik.values.longitude, formik.values.latitude])
      .addTo(map);

    function updateMap() {
      formik.setFieldValue('longitude', map.getCenter().lng.toFixed(4));
      formik.setFieldValue('latitude', map.getCenter().lat.toFixed(4));
      formik.values.longitude = map.getCenter().lng.toFixed(4);
      formik.values.latitude = map.getCenter().lat.toFixed(4);
      marker.setLngLat([formik.values.longitude, formik.values.latitude]);
    }

    map.on('move', () => {
      updateMap();
    });

    document.getElementById('geocoder').appendChild(geocoder.onAdd(map));
    map.addControl(new mapboxgl.FullscreenControl());
    map.addControl(new mapboxgl.NavigationControl());

    async function load() {
      setOpenProgress(true);

      const loadStates = await axios.get(
        'https://servicodados.ibge.gov.br/api/v1/localidades/estados',
      );
      if (loadStates.data.length !== 0) {
        setStates(loadStates.data);
      }

      const resp = await api.get(`/properties/${id}`);

      if (resp.data.length === 0) {
        setOpenDia(true);
      }

      formik.setValues(resp.data);

      //   handleState(
      //    loadStates.data.filter((state) => state === resp.data.state)
      // )

      handleSelectedProperty(resp.data);
      handleState(resp.data.state);
      handleCity(resp.data.city);

      setOpenProgress(false);
    }
    load();
  }, []);

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      user_id: '',
      name: '',
      owner: '',
      phone: '',
      cnpj: '',
      city: '',
      state: '',
      uf: '',
      street: '',
      number: '',
      longitude: -37.3445,
      latitude: -5.1855,
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Campo Obrigatório'),
      owner: Yup.string().required('Campo Obrigatório'),
      phone: Yup.string()
        .required('Campo Obrigatório')
        .matches(
          /^[(]?[0-9]{2}[)]?[\s]?[0-9]{5}[-]?[0-9]{4}$/,
          'O número digitado não é válido.',
        ),
      cnpj: Yup.string()
        .required('Campo Obrigatório')
        .matches(
          /^[0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2}$/,
          'O número digitado não é válido.',
        ),
      city: Yup.string().required('Campo Obrigatório'),
      state: Yup.string().required('Campo Obrigatório'),
      uf: Yup.string(),
      street: Yup.string(),
      number: Yup.number()
        .min(1, 'Número inválido')
        .integer('Número inválido')
        .transform((value) => (isNaN(value) ? undefined : value))
        .typeError(
          'O valor deve ser um número. Caso seja um número decimal utilize " . " ao invés de " , "',
        ),
    }),
    onSubmit: (values) => {
      dispatch(setDisable(true));
      dispatch(setLoading(true));

      request(values);
    },
  });

  // Seta as cidades do estado escolhido
  const handleStateSelect = async (state) => {
    formik.values.state = state.nome;
    formik.values.uf = state.sigla;
    handleState(state);
    formik.values.city = '';

    handleCity(null);
    const loadCities = await axios.get(
      `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${
        state.sigla
      }/municipios`,
    );
    setCities(loadCities.data);
  };

  const handleCitySelect = (city) => {
    formik.values.city = city.nome;

    handleCity(city);
  };

  return (
    <Container>
      {openProgress ? <Progress /> : null}
      {' '}
      {/** Carregamento circular para o carregamento dos dados */}
      <form className={classes.root} onSubmit={formik.handleSubmit}>
        <br />
        <h1 className="title">Dados da Fazenda</h1>

        <FormGroup>
          <TextField
            id="formGridName"
            label="Nome da Fazenda"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            name="name"
            type="text"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={!!(formik.touched.name && formik.errors.name)}
            helperText={
              formik.touched.name && formik.errors.name && formik.errors.name
            }
          />
        </FormGroup>
        <FormGroup>
          <TextField
            id="formGridResp"
            label="Responsável"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            name="owner"
            type="text"
            value={formik.values.owner}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={!!(formik.touched.owner && formik.errors.owner)}
            helperText={
              formik.touched.owner && formik.errors.owner && formik.errors.owner
            }
          />
        </FormGroup>
        <FormGroup>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormGroup>
                <TextField
                  id="formGridStreet"
                  className="formGridStreet"
                  label="Logradouro"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  name="street"
                  type="text"
                  value={formik.values.street}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={!!(formik.touched.street && formik.errors.street)}
                  helperText={
                    formik.touched.street
                    && formik.errors.street
                    && formik.errors.street
                  }
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormGroup>
                <TextField
                  id="formGridNumber"
                  className="formGridNumber"
                  label="Número (Opcional)"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  name="number"
                  type="number"
                  value={formik.values.number}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={!!(formik.touched.number && formik.errors.number)}
                  helperText={
                    formik.touched.number
                    && formik.errors.number
                    && formik.errors.number
                  }
                />
              </FormGroup>
            </Grid>
          </Grid>
        </FormGroup>
        <FormGroup>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                noOptionsText="Sem opções"
                id="combo-box-demo"
                name="state"
                options={states}
                value={selectedState}
                getOptionLabel={(options) => options.nome || selectedState}
                onChange={(p, v) => {
                  handleStateSelect(v);
                }}
                onBlur={formik.handleBlur}
                renderInput={(params) => (
                  <TextField {...params} label="Estado" variant="outlined" />
                )}
                disableClearable
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                noOptionsText="Sem opções"
                name="city"
                options={cities}
                value={selectedCity}
                getOptionLabel={(options) => options.nome || selectedCity}
                onChange={(p, v) => {
                  handleCitySelect(v);
                }}
                onBlur={formik.handleBlur}
                renderInput={(params) => (
                  <TextField {...params} label="Cidade" variant="outlined" />
                )}
                disableClearable
              />
            </Grid>
          </Grid>
        </FormGroup>
        <FormGroup>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="formGridPhone"
                label="Telefone"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="phone"
                type="text"
                value={formik.values.phone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                InputProps={{
                  inputComponent: maskPhone,
                }}
                error={!!(formik.touched.phone && formik.errors.phone)}
                helperText={
                  formik.touched.phone
                  && formik.errors.phone
                  && formik.errors.phone
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="formGridCNPJ"
                className="formGridCNPJ"
                label="CNPJ"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="cnpj"
                InputProps={{
                  inputComponent: maskCNPJ,
                }}
                type="text"
                value={formik.values.cnpj}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!(formik.touched.cnpj && formik.errors.cnpj)}
                helperText={
                  formik.touched.cnpj
                  && formik.errors.cnpj
                  && formik.errors.cnpj
                }
              />
            </Grid>
          </Grid>
        </FormGroup>

        <div id="geocoder" className="geocoder" />
        <div
          ref={(el) => (mapContainer.current = el)}
          className="mapContainer"
        />

        <SaveButton disabled={disableB} />

        {openError ? error() : null}
      </form>
    </Container>
  );
}
export default PropertyChoose;
